module.exports = __webpack_public_path__ + "assets/img/login-bg.832265d1.png";